import React, { useEffect, useState, PureComponent } from 'react';

import { ReactComponent as QrcodePurple } from '../assets/qrcode_purple.svg';
import { ReactComponent as Remove } from '../assets/remove.svg';

import ActivityIcon from './ActivityIcon';

export default function AR ({type, activity, remove, errors, register, name, icon, saveIcon, hideIcon}) {
    return (
        
        <>
        
            <div className="title"> 
                <div>
                    <div className="icon"><img src={icon} alt="" /></div>
                    <div className="name">Settings {name}</div>
                </div>
                <div>
                    <div className="icon qrcode"><QrcodePurple /></div>
                    <div className="icon remove" onClick={remove}><Remove /></div>
                </div>
            </div>

            <ActivityIcon icon={icon} saveIcon={saveIcon} hideIcon={hideIcon} />
            
            <label>Enter {name} name</label>
            <input 
                type="text"
                {...register("name", { required: "Name is required" })}
                placeholder={name + " name"}
                defaultValue={activity['name']}
            />
            <div className="error">{errors.name?.message}</div>                                
            
            
            <div className="subtitle">AR Url</div>
            <label>Enter url</label>
            <input 
                type="text"
                {...register("data[arUrl]", { required: "Url is required" })}
                placeholder={"Url"}
                defaultValue={activity['data']['arUrl']}
            />
            <div className="error">{errors['data'] ? errors['data']['arUrl']?.message : ''}</div>
            
            
            <div className="subtitle">Button</div>
            <label>Enter button text</label>
            <input 
                type="text"
                {...register("data[buttonText]", { required: "Text is required" })}
                placeholder={"Button text"}
                defaultValue={activity['data']['buttonText']}
            />
            <div className="error">{errors['data'] ? errors['data']['buttonText']?.message : ''}</div>
            
        </>
        
    )

}        
        
